import "./Login.css";
import useLogin from "./useLogin";
import { getTranslatedText as translate } from "../../Localization/Translation";
import LanguageSelect from "../../LanguageSelection/LanguageSelect.js";
import { NavLink } from "react-router-dom";

function Login() {
  const {
    locale,
    eye,
    passwordType,
    PhoneNumberError,
    PasswordError,
    Eye,
    onChangeInput,
    checkInput,
    toSignUp,
    backToStartUp,
  } = useLogin();

  return (
    <div className="Login-form">
      <div className="login-form-header-language">
        <div className="Login-form-header">
          {translate("login-form-header", locale)}
        </div>

        {/* Language Selection */}
        <LanguageSelect />
      </div>

      {/* Login Form */}
      <form className="Login-form-inputs">
        <div className="mb-3">
          {/* Phone number */}
          <input
            type="text"
            className="form-control"
            id="LoginPhone"
            onChange={(event) => onChangeInput(event, "LoginPhone")}
            placeholder={translate("login-phone-number-placeholder", locale)}
            aria-describedby="emailHelp"
          />
          <div className="invalid-feedback">
            {translate(PhoneNumberError, locale)}
          </div>
          <div id="emailHelp" className="form-text">
            {translate("login-phone-number-text", locale)}
          </div>
        </div>

        <div className="input-group mb-3">
          {/* Password */}
          <input
            type={passwordType}
            className="form-control"
            id="LoginPassword"
            onChange={(event) => onChangeInput(event, "LoginPassword")}
            placeholder={translate("login-password-placeholder", locale)}
          />
          <div className="input-group-append">
            <i
              onClick={Eye}
              className={`input-group-text eye-pass bi ${
                eye ? "bi-eye-slash" : "bi-eye"
              }`}
            ></i>
          </div>
          <div className="invalid-feedback">
            {translate(PasswordError, locale)}
          </div>
        </div>
        <div className="confirm-signup-buttons">
          <NavLink to="/Navbar/Home/Search" style={{ display: "none" }}>
            <div id="LogIntoHome" style={{ display: "none" }}></div>
          </NavLink>
          <button
            type="submit"
            className="btn btn-primary btn-login-form"
            onClick={checkInput}
          >
            {translate("login-btn-text", locale)}
          </button>
          <button
            type="submit"
            onClick={backToStartUp}
            className="btn btn-secondary"
          >
            {translate("confirm-signup-close-code", locale)}
          </button>
        </div>
      </form>

      {/* Log in With */}
      <hr />
      <div className="signup-with">
        <div className="signup-with-head">
          {translate("login-method-text", locale)}
        </div>
        <div className="row">
          <div className="col signup-method">
            <img
              src="https://img.icons8.com/fluency/48/null/google-logo.png"
              className="signup-method-icon"
              alt="login-method-icon"
            />
            {translate("login-method-1-text", locale)}
          </div>
          <div className="col signup-method">
            <img
              src="https://img.icons8.com/color-glass/48/null/mac-os.png"
              className="signup-method-icon"
              alt="login-method-icon"
            />
            {translate("login-method-2-text", locale)}
          </div>
        </div>
      </div>

      {/* Have No Account */}
      <div className="Login-form-no-account">
        {translate("login-no-account-text", locale)}
        <span className="Login-form-sign-up-btn" onClick={toSignUp}>
          {translate("login-no-account-signup", locale)}
        </span>
      </div>
    </div>
  );
}

export default Login;
